import React, { useEffect, useState } from "react";
import api, { errorText } from "@/lib/api";
import { Modal, PasswordInput } from "@/components/Layout";

// Cardul „Verificare în doi pași” din Contul meu.
export default function MfaCard() {
  const [st, setSt] = useState(null);
  const [ask, setAsk] = useState(null);
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const load = () => api.get("/auth/mfa/status").then(r => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const close = () => { setAsk(null); setPw(""); setError(""); };
  const save = async () => {
    setError("");
    try { await api.post("/auth/mfa/optin", { enabled: ask, password: pw }); close(); load(); }
    catch (e) { setError(errorText(e, "Eroare")); }
  };
  if (!st || st.excluded) return null;   // Superadmin nu folosește 2FA
  let text = "Oprită pentru toată instalarea.";
  if (st.installation_enabled) {
    if (st.required) text = "Activă, obligatorie pentru rolul dumneavoastră: la autentificare primiți un cod pe e-mail.";
    else if (st.optin) text = "Activă: la autentificare primiți un cod pe e-mail.";
    else text = "Neactivă. O puteți porni: la autentificare veți primi un cod pe e-mail.";
  }
  const canOn = st.installation_enabled && !st.required && !st.optin;
  const canOff = st.installation_enabled && !st.required && st.optin;
  return (
    <div className="card" style={{ padding: 22, marginTop: 16 }} data-testid="mfa-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Verificare în doi pași</h3>
        {canOn && <button className="btn btn-primary" onClick={() => setAsk(true)} data-testid="mfa-on">Pornește</button>}
        {canOff && <button className="btn btn-secondary" onClick={() => setAsk(false)} data-testid="mfa-off">Oprește</button>}
      </div>
      <div style={{ fontSize: 12.5, color: "#64748B", marginTop: 8 }} data-testid="mfa-status">
        {text}{st.has_email ? ` Adresa: ${st.email_hint}.` : " Contul nu are adresă de e-mail."}
      </div>
      {ask !== null && (
        <Modal title={ask ? "Pornește verificarea în doi pași" : "Oprește verificarea în doi pași"} onClose={close} width={460}>
          <label className="label label-req">Parola dumneavoastră</label>
          <PasswordInput value={pw} onChange={e => setPw(e.target.value)} testId="mfa-pw" autoComplete="current-password" />
          {error && <div style={{ background: "#FEE2E2", color: "#991B1B", padding: "10px 12px", borderRadius: 8, marginTop: 12, fontSize: 13 }} data-testid="mfa-card-error">{error}</div>}
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
            <button className="btn btn-secondary" onClick={close}>Anulează</button>
            <button className="btn btn-primary" onClick={save} data-testid="mfa-confirm">{ask ? "Pornește" : "Oprește"}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
